function createPolymorphicComponent(component) {
  return component;
}

export { createPolymorphicComponent };
//# sourceMappingURL=create-polymorphic-component.mjs.map
